const GALLERY_OPTIONS = {
  type: 'image',
  gallery: {
    enabled: true,
    navigateByImgClick: true,
  },
  mainClass: 'mfp-fade mfp-interior',
  removalDelay: 200,
  closeOnContentClick: false,
  closeOnBgClick: true,
  enableEscapeKey: true,
  showCloseBtn: true,
  fixedContentPos: true,
  closeMarkup:
    '<button title="%title%" type="button" class="mfp-close mfp-interior-close">&#215;</button>',
};

const closePopup = () => {
  if (window.$ && window.$.magnificPopup) {
    window.$.magnificPopup.close();
  }
};

/**
 * Init Magnific Popup on a gallery root once vendor scripts are ready.
 * Returns a cleanup function.
 */
export const initInteriorLightbox = (element, delegate) => {
  if (!element) return () => {};

  let attempts = 0;
  const maxAttempts = 50;
  let initialized = false;
  let intervalId = null;
  let $gallery = null;

  const onKeyDown = (e) => {
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      e.stopPropagation();
      closePopup();
    }
  };

  const bind = () => {
    if (!window.$ || !window.$.fn.magnificPopup) return false;

    $gallery = window.$(element);
    $gallery.magnificPopup({
      ...GALLERY_OPTIONS,
      delegate,
      callbacks: {
        open() {
          document.addEventListener('keydown', onKeyDown, true);
          document.body.classList.add('mfp-interior-open');
        },
        close() {
          document.removeEventListener('keydown', onKeyDown, true);
          document.body.classList.remove('mfp-interior-open');
        },
      },
    });
    initialized = true;
    return true;
  };

  if (!bind()) {
    intervalId = setInterval(() => {
      attempts += 1;
      if (bind() || attempts >= maxAttempts) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }, 200);
  }

  return () => {
    if (intervalId) clearInterval(intervalId);
    document.removeEventListener('keydown', onKeyDown, true);
    document.body.classList.remove('mfp-interior-open');
    if (initialized && window.$) {
      try {
        closePopup();
      } catch (e) {
        // ignore
      }
      if ($gallery) {
        $gallery.off('click');
        $gallery.removeData('magnificPopup');
      }
    }
  };
};

export default initInteriorLightbox;
